import { useEffect } from "react";
import { usePortal } from "./usePortal";
import { useTheme } from "../../contexts/ThemeContext";
import { useBrandColor } from "../../lib/brandTheme";
import { applyPortalHead } from "../../lib/installPrompt";

/* Client portal: paint the primary token AND the surfaces (body / top bar / sidebar / cards) with the client's (or main
   client's) brand colour, re-tuned whenever the user flips Light / Dark / Match my device — and point the manifest,
   home-screen icon and app title at the client's own so "Add to home screen" installs *their* app. Renders nothing. */
export function PortalTheme() {
  const { me } = usePortal();
  const { theme } = useTheme();
  const b = me?.branding || {};
  useBrandColor(b.primary_color || "", { mode: theme, surfaces: true });
  useEffect(() => applyPortalHead({ slug: b.portal_slug, companyName: b.company_name }), [b.portal_slug, b.company_name]); // status bar follows the tinted top bar via useStatusBarTheme
  return null;
}
